import axios from "axios";

const normalizeBoolean = (value) => {
  if (typeof value === "string") {
    return value.trim().toLowerCase() === "true";
  }
  return Boolean(value);
};

export const resolveBaseURL = () => {
  const useProxy = normalizeBoolean(process.env.REACT_APP_API_USE_PROXY);
  const explicitBase =
    process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_ENDPOINT;

  if (explicitBase) {
    return explicitBase.replace(/\/$/, "");
  }

  if (useProxy) {
    const proxyPath = process.env.REACT_APP_PROXY_PATH || "/api/v1";
    return proxyPath.replace(/\/$/, "");
  }

  return "/api/v1";
};

const apiClient = axios.create({
  baseURL: resolveBaseURL(),
  withCredentials: true,
});

apiClient.interceptors.request.use((config) => {
  config.headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
    ...config.headers,
  };

  // Token is sent automatically as HttpOnly cookie via withCredentials: true
  return config;
});

export default apiClient;
